import "./index.scss";

// layout
import Section from "../components/section/section.jsx";

// components
import Navigation from "../components/navigation/navigation.jsx";
import Stage from "../components/stage/stage.jsx";
import Footer from "../components/footer/footer.jsx";
import Portfolio from "../components/portfolio/portfolio.jsx";
import Button from "../components/button/button.jsx";
import Logolist from "../components/logolist/logolist.jsx";
import Link from "../components/link/link.jsx";
import Overlay from "../components/overlay/overlay.jsx";

import data from "./data/data.json";
import { useEffect, useContext } from "react";

import { ThemeContext } from "../App";

function Home() {
  const { visibleSection, setVisibleSection } = useContext(ThemeContext);

  const newScrollEvent = function ({ positions, sections }) {
    // Get the current scroll position
    const scrollPosition = window.scrollY;
    const windowHalfHeight = window.innerHeight / 2;

    positions.forEach((section, index) => {
      if (
        scrollPosition >= section - windowHalfHeight &&
        index + 1 <= positions.length &&
        scrollPosition < positions[index + 1] - windowHalfHeight &&
        visibleSection !== sections[index].id
      ) {
        setVisibleSection(sections[index].id);
      }
    });
  };

  const getPositions = function () {
    // Get all sections
    const sections = document.querySelectorAll(".section");
    const positions = [];

    sections.forEach((section, index) => {
      positions.push(section.offsetTop);
    });

    return { positions, sections };
  };

  useEffect(() => {
    document.removeEventListener("scroll", () =>
      newScrollEvent(getPositions())
    );

    document.addEventListener("scroll", () => newScrollEvent(getPositions()));
  }, [visibleSection]);

  useEffect(() => {
    document.addEventListener("scroll", () => newScrollEvent(getPositions()));
  }, []);

  return (
    <div className="main">
      <Navigation
        items={[
          { name: "Über Mich", id: "about" },
          { name: "Portfolio", id: "portfolio" },
          { name: "Agenturen", id: "agenturen" },
          { name: "Tools", id: "tools" },
          { name: "Kontakt", id: "contact" },
        ]}
      />

      {/* Stage */}
      <Section className="home" id="home" fullWidth noPadding>
        <Stage />
      </Section>

      {/* About */}
      <Section title="Über mich" className="about" id="about">
        <p className="about">
          Mein Name ist Lennart, ich habe Kommunikationsdesign studiert und habe
          bereits in meinem Studium gemerkt, dass ich starkees Interesse an der
          Programmierung habe. Daher hab ich im Studium bereits Kurse in
          Programmierung ( damals Actionscript, HTML und CSS ) belegt.
          <br />
          <br />
          Nach dem Studium habe ich mich privat weiter mit der Programmierung
          beschäftigt und habe über Foren und Dokumentationen weitere Kenntnisse
          aufgebaut. Anschließend bin ich als Frontend-Entwickler ins
          Agenturleben eingestiegen und durfte dort direkt spannende Projekte
          betreuen.
          <br />
          <br />
          In fast 6 Jahren Agenturleben konnte ich fundiertes Wissen in der
          Programmierung aufbauen. Ich beschäftigte mich mit verschiedenen
          Frameworks aber auch mit dem Komponententesting, Projektarchitekturen
          und Codequalität.
          <br />
          <br />
          Fall Sie ein spannendes Projekt haben, zögern Sie nicht mich zu
          kontaktieren!
        </p>

        <Link
          href="/pdf/cv-lennart-kallert.pdf"
          download
          ariaLabel="lädt die cv herunter"
        >
          <Button text="Download CV" ariaLabel="lädt die cv herunter" />
        </Link>

        <Button
          text="Kontakt"
          onClick={() => {
            const target = document.getElementById("contact");

            if (target) {
              target.scrollIntoView({ behavior: "smooth" });
            }
          }}
          ariaLabel="Scrollt in den Kontaktbereich"
        />
      </Section>

      {/* Portfolio */}
      <Section title="Portfolio" id="portfolio">
        <Portfolio />
      </Section>

      {/* Agenturen und Marken */}
      <Section title="Agenturen" id="agenturen">
        {/* Agenturen */}
        <Logolist items={data.agencies} grid="3" imageClass="brands" brands />
      </Section>

      {/* Tools */}
      <Section title="Tech-Stack und Tools" id="tools">
        {/* Languages */}
        <Logolist title="Tech" items={data.languages} maxHeight grid="5" />

        {/* Tools */}
        <Logolist title="Tools" items={data.tools} maxHeight grid="5" />

        {/* In Progress */}
        <Logolist
          title="In Progress"
          items={data.inProgress}
          inProgress
          maxHeight
          grid="5"
        />
      </Section>

      {/* Footer */}
      <Footer />

      {/* Overlay */}
      <Overlay />
    </div>
  );
}

export default Home;
